import { render } from "./BaseAccountDesktopView.vue?vue&type=template&id=3e2bfc3e&scoped=true"
import script from "./BaseAccountDesktopView.vue?vue&type=script&lang=js"
export * from "./BaseAccountDesktopView.vue?vue&type=script&lang=js"

import "./BaseAccountDesktopView.vue?vue&type=style&index=0&id=3e2bfc3e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e2bfc3e"]])

export default __exports__